<template>
  <div class="product-wearable">
    <!-- Main Image Start -->
    <div class="product__bg-image">
      <div class="bg-video">
        <!-- language check -->
        <template v-if="$i18n.locale() === 'ko'">
          <!-- ** lang KO Start ** -->
          <!-- todo: 비디오 (ko) -->
          <video src="../assets/videos/product_wearable_clean.mp4"
                 @canplay="updatePaused"
                 @playing="updatePaused"
                 @pause="updatePaused"
                 autoplay muted loop playsinline></video>
          <!-- ** lang KO End ** -->
        </template>
        <template v-else>
          <!-- ** lang EN Start ** -->
          <!-- todo: 비디오 (en) -->
          <video src="../assets/videos/product_wearable_clean.mp4"
                 @canplay="updatePaused"
                 @playing="updatePaused"
                 @pause="updatePaused"
                 autoplay muted loop playsinline></video>
          <!-- ** lang EN Start ** -->
        </template>
        <!-- language check -->
        <!-- ** lang KO Start ** -->
        <!-- ** lang EN Start ** -->
      </div>
      <div class="bg-video__cover"></div>
      <div class="bg-video__content">
        <!-- language check -->
        <template v-if="$i18n.locale() === 'ko'">
          <!-- ** lang KO Start ** -->
          <div class="bg-image__sub-title wearable no-drag sub-title--ko"
               data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="400">
            <span>{{$t('wearable.title')}}</span>
          </div>
          <div class="bg-image__title wearable no-drag title--ko"
               data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="300">
            <span v-html="$t('wearable.sub-title')"></span>
          </div>
        </template>
        <!-- ** lang KO End ** -->
        <!-- ** lang EN Start ** -->
        <template v-else>
          <div class="bg-image__title wearable no-drag"
               data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="300">
            <span v-html="$t('wearable.title')"></span>
          </div>
          <div class="bg-image__sub-title wearable no-drag"
               data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="400">
            <span>{{$t('wearable.sub-title')}}</span>
          </div>
          <!-- ** lang EN Start ** -->
        </template>
      </div>
    </div>
    <!-- Main Image End -->

    <!-- electronics-printed Start -->
    <wearable-electronics-printed/>
    <!-- electronics-printed End -->

    <!-- application Start -->
    <wearable-app/>
    <!-- application End -->
  </div>
</template>

<script>
import { FadeUpMixin } from '@/components/mixins/FadeUp';
import { setLanguageMixin } from '@/components/mixins/setLanguage';
import WearableElectronicsPrinted from '../components/productWearable/WearableElectronicsPrinted.vue';
import WearableApp from '../components/productWearable/WearableApp.vue';

export default {
  name: 'ProductWearable',
  components: {
    WearableElectronicsPrinted,
    WearableApp,
  },
  data() {
    return {
    };
  },
  mixins: [setLanguageMixin, FadeUpMixin],
  methods: {
  },
};
</script>

<style lang="scss" scoped>
  @import "../assets/scss/bgImage";

  .product-wearable {
    flex-shrink: 0;
  }

  .bg-image__title.title--ko{
    margin-bottom: 17px;
  }

</style>
